<script setup lang="ts">
import { ref } from 'vue'
import { useAppState } from '@/stores/AppState'

const appState = useAppState()
let tooltipDisabled = ref(true)

// Define the event type for the checkEllipses method for TypeScript
interface CheckEllipsesEvent extends Event {
  target: HTMLElement & {
    querySelector: (selectors: string) => HTMLElement | null
  }
}

function checkEllipses(event: CheckEllipsesEvent) {
  // Find the v-card-subtitle element within the v-card
  const cardSubtitle = event.target.querySelector('.card-subtitle')
  // Find the v-card-title element within the v-card
  const cardTitle = event.target.querySelector('.card-title')
  // Check if the cardSubtitle or cardTitle has ellipses
  if (
    (cardSubtitle && cardSubtitle.scrollWidth > cardSubtitle.clientWidth) ||
    (cardTitle && cardTitle.scrollWidth > cardTitle.clientWidth)
  ) {
    tooltipDisabled.value = false // Enable the tooltip
  } else {
    tooltipDisabled.value = true // Disable the tooltip
  }
}
</script>
<template>
  <div class="grid grid-container" id="secHomeDesktop">
    <template
      v-for="(feature, index) in appState.$state.discovery?.features.filter(
        (f) => f.componentName !== null && f.permission === 'HasAccess'
      )"
    >
      <v-tooltip right max-width="300" :disabled="tooltipDisabled" id="secHomeDesktopTooltip">
        <template v-slot:activator="{ props }">
          <v-card
            :key="index"
            :to="feature.defaultPath"
            class="card"
            @mouseenter="checkEllipses"
            v-bind="props"
            id="secHomeDesktopCard"
          >
            <v-card-title class="overflow-elips card-title" id="secHomeDesktopCardTitle">
              {{ feature.name }}
            </v-card-title>
            <v-icon class="card-icon" id="secHomeDesktopCardIcon">
              {{ feature.materialDesignIconName }}
            </v-icon>
            <v-card-subtitle class="overflow-elips card-subtitle" id="secHomeDesktopCardSubtitle">
              {{ feature.description }}
            </v-card-subtitle>
          </v-card>
        </template>
        <div v-html="`<p>${feature.name}</p><br><p>${feature.description}</p>`"></div>
      </v-tooltip>
    </template>
  </div>
</template>
<style scoped>
.grid-container {
  padding: 2rem 0;
  grid-template-columns: repeat(3, 1fr);
  grid-gap: 2vw;
}
.card {
  display: grid;
  grid-template-columns: 1fr 0fr;
  grid-template-rows: 1fr 1fr;
  gap: 0px 0px;
  grid-template-areas:
    'title icon'
    'subtitle icon';
  padding: 0.5rem;
}
.card-title {
  grid-area: title;
  align-self: self-start;
  padding-bottom: 0;
}
.card-icon {
  grid-area: icon;
  color: var(--accent-color);
  font-size: xxx-large;
  justify-self: center;
  align-self: center;
  margin: 1rem;
}
.card-subtitle {
  grid-area: subtitle;
  align-self: center;
}
</style>
